import { Card, Text, Group, Box } from "@mantine/core";
import { countries } from "countries-list";
import Flags from "country-flag-icons/react/3x2";
import { useTranslation } from "react-i18next";
import { getTranslatedMonth } from "@congrs/utils";

const AdditionalFieldDisplay = ({ fieldKey, value, fieldType }) => {
  const { t } = useTranslation();
  const renderCountry = () => {
    if (!value) {
      return <Text>Not provided</Text>;
    }
    const country = countries[value.toUpperCase()];
    const FlagComponent = Flags[value.toUpperCase()];
    return (
      <Group gap="xs" align="center">
        {FlagComponent && <FlagComponent height="12px" />}
        <Text>{country ? country.name : value}</Text>
      </Group>
    );
  };

  const renderDate = () => {
    if (!value) {
      return <Text>Not provided</Text>;
    }
    return (
      <Text>{`${String(new Date(value).getDate()).padStart(2, "0")} ${getTranslatedMonth(value, t)} ${new Date(value).getFullYear()}`}</Text>
    );
  };

  const renderArray = () => (
    <Box>
      {value.map((item, idx) => (
        <Text key={idx}>{item}</Text>
      ))}
    </Box>
  );

  const renderDefault = () => <Text>{value || "Not provided"}</Text>;

  const renderContent = () => {
    if (fieldType === "country") {
      return renderCountry();
    }
    if (fieldType === "date") {
      return renderDate();
    }
    if (Array.isArray(value)) {
      return renderArray();
    }
    if (typeof value === "boolean") {
      return <Text>{value ? "Yes" : "No"}</Text>;
    }
    return renderDefault();
  };

  return (
    <Card shadow="xs" p="sm" radius="md" withBorder>
      <Text size="sm" c="gray">
        {fieldKey}
      </Text>
      {renderContent()}
    </Card>
  );
};

export default AdditionalFieldDisplay;
